import { Component } from 'preact'

class Fonts extends Component {
    render(props) {
        return (
            <style>
                @font-face {'{'}
                font-family: 'Custom';
                src: url({props.fonts[0].filename});
                font-weight: 200;
                {'}'}
                @font-face {'{'}
                font-family: 'Custom';
                src: url({props.fonts[1].filename});
                font-weight: 400;
                {'}'}
                @font-face {'{'}
                font-family: 'Custom';
                src: url({props.fonts[2].filename});
                font-weight: 600;
                {'}'}
                @font-face {'{'}
                font-family: 'Custom';
                src: url({props.fonts[3].filename});
                font-weight: 800;
                {'}'}
            </style>
        )
    }
}

export default Fonts



// WEBPACK FOOTER //
// ./components/Fonts.js